import { createRoutine } from 'redux-saga-routines';
// common
import { createCRUDRoutine } from '../../common/routines';
//////////////////////////////////////////////////

const BOARD = 'BOARD';
const BOARD_PAGINATION = 'BOARD_PAGINATION';

const boardRoutine = createCRUDRoutine(BOARD);
const boardPaginationRoutine = createRoutine(BOARD_PAGINATION);

export {
  boardRoutine,
  boardPaginationRoutine,
};
